module.exports = __webpack_public_path__ + "static/media/close-button-icon-white.9940914f.svg";